
import { computed, ComputedRef } from "vue";
import { useStore } from "@/store";
import { PlayerBattleProperty } from "@/store/player/types";
const store = useStore();
export default {
  name: "Attrs",
  setup() {
    const currentAttrs: ComputedRef<PlayerBattleProperty> = computed(() => {
      return store.getters.playerBattleProperty;
    });

    return {
      currentAttrs
    };
  }
};
